import { spreadNodes } from "@/mocks/homeData";

export default function SpreadTimeline() {
  return (
    <section id="timeline" className="bg-stone-100 scroll-mt-4">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6 py-12 md:py-16">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,340px)_1fr] lg:gap-14">
          {/* 左侧区隔说明 */}
          <div className="lg:sticky lg:top-6 lg:self-start">
            <div className="flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-red-600">
              <i className="ri-time-line"></i> 引爆时间线
            </div>
            <h2 className="mt-3 font-serif text-2xl font-black tracking-tight text-stone-900 md:text-4xl">
              一条爆料，如何刷屏全网
            </h2>
            <p className="mt-3 text-sm leading-7 text-stone-500">
              我们把每一起登上热搜的话题，按时间拆成可复盘的引爆路径。从原点落地的第一帧，到转发刷屏的全网狂欢，每一步都对应明确的扩散信号。
            </p>
            <div className="mt-5 inline-flex items-center gap-2 rounded-md border border-red-200 bg-red-50 px-3 py-1.5 text-xs font-semibold text-red-700">
              <i className="ri-error-warning-line"></i> 评论区沦陷指数已达高危阈值
            </div>
            <p className="mt-4 text-xs leading-6 text-stone-400">
              以下为事件还原的扩散节奏示意图，指标为平台口径的监测还原，仅作路径观察用途。
            </p>
          </div>

          {/* 右侧时间轴 */}
          <div className="relative pl-6 md:pl-8">
            <div className="absolute bottom-0 left-[7px] top-2 w-px bg-gradient-to-b from-red-600 via-orange-300 to-stone-200 md:left-[9px]"></div>
            <div className="flex flex-col gap-5">
              {spreadNodes.map((node, i) => (
                <div key={node.time} className="relative">
                  <div
                    className={`absolute -left-6 top-5 flex h-[15px] w-[15px] items-center justify-center rounded-full ring-4 ring-stone-100 md:-left-8 ${
                      i === 0 ? "bg-red-600" : i === spreadNodes.length - 1 ? "bg-stone-900" : "bg-orange-500"
                    }`}
                  ></div>
                  <div className="ml-5 flex flex-col gap-2 rounded-lg border border-stone-200 bg-white p-4 transition-colors hover:border-red-200 md:ml-6 md:flex-row md:items-start md:gap-6 md:p-5">
                    <div className="flex items-center gap-2 md:w-28 md:flex-col md:items-start">
                      <span className="font-mono text-xs font-bold tracking-wider text-red-600">{node.time}</span>
                      <span className="whitespace-nowrap rounded bg-stone-900 px-2 py-0.5 text-[11px] font-bold text-white">
                        {node.label}
                      </span>
                    </div>
                    <div className="flex gap-3">
                      <span className="hidden h-9 w-9 shrink-0 items-center justify-center rounded-full bg-stone-100 text-base text-red-600 sm:flex">
                        <i className={node.icon}></i>
                      </span>
                      <div>
                        <h3 className="text-base font-bold text-stone-900 md:text-lg">{node.title}</h3>
                        <p className="mt-1 text-sm leading-6 text-stone-500">{node.desc}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}